import { Fragment, useEffect, useState } from 'react';
import { GoClockFill } from "react-icons/go";
import Moment from 'react-moment';
import { MdArrowBackIos } from 'react-icons/md';
import TaskNotificationsSkeleton from '../TaskSkeleton/TaskNotificationsSkeleton';
import { useSelector } from 'react-redux';
import { GET_SEPERATOR } from '../../../../Utils/Common';

// // Demo static notification data
// const demoNotifications = [
//     {
//         id: 1,
//         created_by_name: 'John Doe',
//         title: 'Task status changed to In Progress',
//         created_at: new Date(Date.now() - 1000 * 60 * 5) // 5 minutes ago
//     },
//     {
//         id: 2,
//         created_by_name: 'Jane Smith',
//         title: 'Added a new comment on the task',
//         created_at: new Date(Date.now() - 1000 * 60 * 30) // 30 minutes ago
//     },
//     {
//         id: 3,
//         created_by_name: 'Mike Johnson',
//         title: 'Assigned the task to Sarah Wilson',
//         created_at: new Date(Date.now() - 1000 * 60 * 60 * 2) // 2 hours ago
//     },
//     {
//         id: 4,
//         created_by_name: 'Sarah Wilson',
//         title: 'Updated the task due date',
//         created_at: new Date(Date.now() - 1000 * 60 * 60 * 24) // 1 day ago
//     },
//     {
//         id: 5,
//         created_by_name: 'Alex Brown',
//         title: 'Changed task priority to High',
//         created_at: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2) // 2 days ago
//     }
// ];

// const GET_SEPERATOR = (prev, current) => {
//     if (!prev) return 'Today';
//     const prevDate = new Date(prev.created_at).toDateString();
//     const currDate = new Date(current.created_at).toDateString();
//     if (prevDate !== currDate) {
//         return currDate;
//     }
//     return '';
// };

const TaskDetailsNotificationsNew = ({ onClose }) => {
    // const [loading, setLoading] = useState(true);
    // const notifications = demoNotifications;

    // useEffect(() => {
    //     setLoading(true);
    //     const timeout = setTimeout(() => {
    //         setLoading(false);
    //     }, 1000);
    //     return () => clearTimeout(timeout);
    // }, []);

    const { active_task } = useSelector(state => state.task);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 1000); // simulate API delay

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className='task w-full h-full fixed z-[16] bg-white top-0 properties animate__animated animate__zoomIn animation_duration'>
            <header className="filterFileHeader">
                <div className="allfilterFileHeader !ml-2" onClick={onClose}>
                    <MdArrowBackIos className="allFileHeaderIcon text-2xl !mt-[0px]" />
                    <span className="allFileHeaderText">Notifications</span>
                </div>
            </header>
            <div className='w-full h-full overflow-y-auto flex flex-col gap-4' style={{ height: 'calc(100vh - 100px)' }}>
                {loading ? (
                    [...Array(10)].map((_, idx) => (
                        <TaskNotificationsSkeleton key={idx} />
                    ))
                ) : (
                    <div className='px-4'>
                        {active_task?.notification?.length > 0 ?
                            active_task?.notification?.map(m => ({ ...m, created_at: m.created_at }))?.map((v, k) => {
                                let separator = GET_SEPERATOR(active_task?.notification?.[k - 1], v)
                                return (
                                    <Fragment key={'noti_' + k}>
                                        {separator !== '' && <div className="msgSeparator !mt-3 mb-3" ><p className="z-[1] bg-teal-50">{separator}</p></div>}
                                        <div key={v.id} className='flex gap-2 w-full pb-4'>
                                            <div className="w-10 h-10">
                                                <img
                                                    src={'https://wfss001.freeli.io/profile-pic/Photos/img.png'}
                                                    alt="user"
                                                    title="user"
                                                    className='!max-w-10 rounded-full object-cover'
                                                />
                                            </div>
                                            <div>
                                                <div className='flex gap-1'>
                                                    <p className="text-base text-grey-600 font-bold dark:text-white">{v.created_by_name}</p>
                                                    <div className="flex items-center gap-1">
                                                        <GoClockFill className='text-sm text-teal-600' />
                                                        <time className='text-sm text-grey-600 dark:text-white'><Moment format="h:mm A">{v?.created_at}</Moment></time>
                                                    </div>
                                                </div>
                                                <div><p className='text-sm text-grey-600 dark:text-white'>{v.title}</p></div>
                                            </div>
                                        </div>
                                    </Fragment>
                                )
                            })
                            :
                            <div className='flex flex-col items-center gap-2 mt-10'>
                                <p className='text-sm text-grey-600 dark:text-white'>No notifications yet.</p>
                            </div>
                        }
                    </div>
                )}
            </div>
        </div>
    );
};


export default TaskDetailsNotificationsNew;